import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUserTie, 
  faUserShield, 
  faCrown, 
  faGavel,
  faUserCog,
  faUserNinja
} from '@fortawesome/free-solid-svg-icons';


import { staffByRole, roleHierarchy } from '../../data/staffMembers';


import StaffCard from '../staff/StaffCard';

const StaffList = () => {

  const getRoleIcon = (role) => {
    const icons = {
      'Network Owner': faCrown,
      'Manager': faUserTie,
      'Tierlist Administrator': faUserCog,
      'Regulator': faGavel,
      'Moderator': faUserShield,
      'Senior Tester': faUserNinja
    };
    
    return icons[role] || faUserShield;
  };
  

  const getRoleColor = (role) => {
    const colors = {
      'Network Owner': 'bg-red-500',
      'Manager': 'bg-orange-500',
      'Tierlist Administrator': 'bg-yellow-500',
      'Regulator': 'bg-green-500',
      'Moderator': 'bg-blue-500',
      'Senior Tester': 'bg-purple-500'
    };
    
    return colors[role] || 'bg-gray-500';
  };
  

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    },
    exit: {
      opacity: 0,
      y: 30,
      transition: { duration: 0.3 }
    }
  };
  
  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <motion.div
        variants={sectionVariants}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold mb-4">
          Staff List
        </h1>
        <p className="text-text-secondary">
          Below is a list of all current staff members organized by role hierarchy.
        </p>
      </motion.div>
      
      <motion.div
        variants={containerVariants}
        className="space-y-12"
      >
        {}
        {roleHierarchy.map((role) => (
          <motion.div 
            key={role}
            variants={sectionVariants}
            className="mb-8"
          >
            <div className="flex items-center mb-6">
              <FontAwesomeIcon 
                icon={getRoleIcon(role)} 
                className={`mr-3 p-2 ${getRoleColor(role)} text-white rounded-full`} 
              />
              <h2 className="text-2xl font-semibold">
                {role}
              </h2>
              <div className="ml-4 h-1 flex-grow bg-primary bg-opacity-20 rounded-full" />
            </div>
            
            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {staffByRole[role].map((member, index) => (
                <StaffCard
                  key={member.id}
                  username={member.username}
                  role={member.role}
                  subroles={member.subroles}
                  discord={member.discord}
                  skinUrl={member.skinUrl}
                  index={index}
                />
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default StaffList;